import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import { useEffect, useState } from "react";
import { Col, Row } from "@/utils/bootstrap";
import { FieldValues, UseFormReturn } from "react-hook-form";
import RadioHook from "../RadioHook";
import { IBranch } from "@/api/AppApi/services/company/interfaces/ICompany";
import { getBranchIdCookie } from "@/utils/functions/cookieOperations";
import BranchDetailsPopup from "./branch-helpers/BranchDetailsPopup";
import NextImage from "@/app/components/lib/NextImage";
import InputErrorMsg from "@/app/components/common-form-builder/form-builder-helpers/InputErrorMsg";
import { useTranslation } from "@/hooks/localization/useTranslations";
import { useGetProfileQuery } from "@/api/AppApi/services/auth";
import { useAtom } from "jotai";
import { isSignedInAtom } from "@/hooks/authAtoms";
import { receivingBranchAtom } from "@/hooks/receivingHeaderAtom";

interface Props {
  form: UseFormReturn<FieldValues, any>;
  fieldName: string;
  className?: string;
  mobile: boolean;
}
const CheckoutBranchesPopUp: React.FC<Props> = ({ form, fieldName }) => {
  const [branchToViewDetails, setBranchToViewDetails] =
    useState<IBranch | null>(null);
  const t = useTranslation();
  const getCompany = useGetCompanyQuery();
  const getProfile = useGetProfileQuery();
  const [, setreceivingBranch] = useAtom(receivingBranchAtom);
  const [isSignedIn] = useAtom(isSignedInAtom);
  const { pickup_branch } = getProfile?.data?.result?.settings ?? {};
  const pickupBranchId = pickup_branch!;
  const branches = getCompany?.data?.result?.branches ?? [];
  useEffect(() => {
    if (!getCompany?.data?.result || (isSignedIn && getProfile.isLoading))
      return;
    const initialBranchId =
      pickupBranchId ??
      branches.map((branch) => branch.id).includes(+getBranchIdCookie())
        ? +getBranchIdCookie()
        : branches[0].id;
    const initialBranch = branches.find(
      (branch) => branch.id === initialBranchId,
    );
    setTimeout(() => form.setValue(fieldName, initialBranchId));
    setreceivingBranch(initialBranch!);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getCompany?.data?.result, getProfile.isLoading]);
  return (
    <>
      {branchToViewDetails ? (
        <BranchDetailsPopup
          onCloseInPopuUp={() => {
            setBranchToViewDetails(null);
          }}
          inPopUp
          branch={branchToViewDetails}
          show={!!branchToViewDetails}
          setShow={() => setBranchToViewDetails(null)}
        />
      ) : (
        <div className="branches" style={{ border: "none" }}>
          {branches?.map((branch, key) => (
            <div key={key} className="branch">
              <Row className="m-0 name" style={{ gap: 4 }}>
                <Col className="p-0 col-auto ">
                  <RadioHook
                    form={form}
                    option={{ id: branch.id, value: branch.name }}
                    fieldName={fieldName}
                    onOptionChange={() => {
                      setreceivingBranch(branch!);
                    }}
                    isRequired
                  />
                </Col>
                <Col className="p-0">
                  <NextImage
                    src={branch.thumbnail_url ?? branch.image_url}
                    alt="pay"
                    width={20}
                    height={14}
                    objectFit="cover"
                  />
                </Col>
              </Row>
              <div className="address">{branch.address ?? t.noAddress}</div>
              <div
                className="view-details"
                onClick={() => {
                  setBranchToViewDetails(branch);
                }}
              >
                {t.view_details}
              </div>
            </div>
          ))}

          {form.formState.errors[fieldName] && (
            <InputErrorMsg
              errorMsg={form.formState.errors[fieldName]?.message as string}
            />
          )}
        </div>
      )}
    </>
  );
};

export default CheckoutBranchesPopUp;
